import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const OrderVilla = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <path
      d="M12 4.79L20.5 9.49V20H3.5V9.49L12 4.79ZM12 2.5L1.5 8.31V22H22.5V8.31L12 2.5Z"
      fill="currentColor"
    />
    <path
      d="M15.5 21V14H8.5V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path d="M13.75 8H10.25V10.5H13.75V8Z" fill="currentColor" />
  </SvgIcon>
);

export default OrderVilla;
